module.exports = __webpack_public_path__ + "media/outside-2-480.3c1461ce.mp4";